<template>
  <el-container>
    <!-- 左侧边栏菜单 -->
    <el-aside :width="isCollapse?'64px':'200px'">
      <!-- logo -->
      <div :class="['logo',isCollapse?'logo-active':'logo-active1']" v-if="!isCollapse">
        <!-- <img src="../assets/image/logo1.png" alt /> -->
        <img src="../assets/Logo04.png">
      </div>
      <div class="logo1" v-if="isCollapse">
        <!-- <img src="../assets/image/logo.png" alt /> -->
        <img src="../assets/Logo03.png">
      </div>
      <el-menu background-color="#202239" text-color="#919191" :unique-opened="true" :collapse="isCollapse"
               :collapse-transition="false" router :default-active='$route.path'>
        <el-menu-item @click="handleActiveMenus('/index')" index="/index">
          <i class="iconfont icon-shuju"></i>
          <span slot="title" style="color: #FFFFFF;">首页</span>
        </el-menu-item>
        <!-- <el-menu-item @click="handleActiveMenus('/notice')" index="/notice">
            <i class="iconfont icon-tongzhi"></i>
            <span slot="title">通知中心</span>
          </el-menu-item> -->
        <!-- <el-menu-item @click="handleActiveMenus('/evaluate')" index="/evaluate">
          <i class="iconfont icon-tubiaozhizuomoban"></i>
          <span style="color: #FFFFFF;">评价管理</span><el-badge is-dot v-if="dot" class="badge">
          </el-badge>
        </el-menu-item> -->
        <el-menu-item @click="handleActiveMenus('/attendance')" index="/attendance">
          <i class="iconfont icon-kaoqin"></i>
          <span style="color: #FFFFFF;">考勤中心</span>
          <el-badge class="badge">
          </el-badge>
        </el-menu-item>
        <!-- 一级菜单 -->
        <el-submenu :index="item.id+''" v-for="item in menulist" :key="item.id">
          <template slot="title">
            <i :class="item.icon"></i>
            <span>{{ item.name }}</span>
            <el-badge :value="noFollowUpCount" style="margin-left: 10px;"
                      v-if=" item.id == 15 && noFollowUpCount!=0"></el-badge>
          </template>
          <!-- 二级菜单 -->
          <template v-for="itemChild in item.childs">
            <el-submenu v-if="itemChild.childs && itemChild.childs.length" :index="itemChild.id+''"
                        :key="itemChild.path">
              <template slot="title">
                <span>{{ itemChild.name }}</span>
              </template>
            </el-submenu>
            <el-menu-item v-else :index="itemChild.path" :key="itemChild.path">{{ itemChild.name }}
            </el-menu-item>
          </template>
        </el-submenu>
        <!-- <el-menu-item @click="handleActiveMenus('/fault')" index="/fault">
          <i class="iconfont icon-tubiaozhizuomoban"></i>
          <span style="color: #FFFFFF;">问题反馈</span><el-badge is-dot v-if="dot" class="badge">
          </el-badge>
        </el-menu-item> -->
      </el-menu>
    </el-aside>
    <!-- 右侧 -->
    <el-container>
      <!-- 右侧头部 -->
      <el-header>
        <i :class="['iconfont', 'icon-caidan',isCollapse?'iconfont-active':'']" @click="handleToggle"
           style="cursor: pointer;"></i>
        <div class="user_box">
          <el-badge :value="0" class="item">
            <i style="font-size: 20px" class="iconfont icon-lingdang" @click="openmessage"></i>
          </el-badge>
          <el-dropdown>
            <div class="head">
              <img src="../assets/workerhead.jpg"/>
              <i class="iconfont icon-xiajiantou"></i>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item>
                  <el-button @click="manage" type="text"><span style="color: #000000;">管理</span>
                  </el-button>
                </el-dropdown-item>
                <el-dropdown-item>
                  <el-button @click="outlogin" type="text"><span style="color: #000000;">退出</span>
                  </el-button>
                </el-dropdown-item>
              </el-dropdown-menu>
            </div>
          </el-dropdown>
        </div>
      </el-header>
      <!-- 右侧main -->
      <el-main>
        <!-- 路由占位符 -->
        <router-view/>
        <!-- <div class="div-footer" style="color: #777777;">—— 潮剪 V2022-06-09@ciaojian.com ——</div> -->
        <div class="div-footer" style="color: #777777;">—— 潮剪 V
          {{
            new Date().getFullYear() + '-' +
            ((new Date().getMonth() + 1) > 9 ? (new Date().getMonth() + 1) : ('0' + (new Date().getMonth() + 1))) + '-' +
            (new Date().getDate() > 9 ? new Date().getDate() : ('0' + new Date().getDate()))
          }}
          @ciaojian.com ——
        </div>
      </el-main>
      <!-- 右侧底部 -->
    </el-container>
    <el-drawer class="home_drawer" title="待处理事项" :visible.sync="show_message" style="height:100%;outline: 0;"
               :append-to-body="true">
      <div class="message_box">
        <div class="matter">
          <div class="mynotice" v-for="i in list" :key="i">
            <div class="nos">【 通知 】</div>
            <span class="wos">【 审批 】</span>
            <div class="mynoswww">西门口直营店8月10日开业</div>
            <div style="color: #AEAEAE;">已读</div>
          </div>
          <div class="mynotice">
            <span class="mynoswww">西门口直营店8月10日开业</span>
            <div>未读</div>
          </div>
        </div>
        <el-button type="text" class="showxiangqing" @click="showxiangqing">点击查看详情</el-button>
        <el-pagination style="margin: 20px" :current-page="filter.page" :page-size="filter.pagesize"
                       layout=" prev, pager, next" :total="count" @current-change="changePage"/>
      </div>
    </el-drawer>
  </el-container>
</template>
<script>
let t
export default {
  data() {
    return {
      tiem: '',
      list: [],
      filter: {
        page: 10,
        pagesize: 10
      },
      show_message: false, //是否显示弹窗
      count: 100,
      noFollowUpCount: 0,
      // 菜单栏列表
      menulist: [
        {
          id: 1,
          name: "数据监测",
          icon: 'iconfont icon-fankui',
          childs: [{
            id: 101,
            name: "总运营数据监测",
            path: "/totalRevenueData",
          }, {
            id: 102,
            name: "门店运营数据监测",
            path: "/storeRevenueData",
          }, {
            id: 103,
            name: "发型师运营数据监测",
            path: "/workerRevenueData",
          }, {
            id: 104,
            name: "项目运营数据监测",
            path: "/serviceRevenueData",
          },],
        },
        {
          id: 2,
          name: "反馈中心",
          icon: 'iconfont icon-fankui',
          childs: [{
            id: 201,
            name: "问题反馈",
            path: "/fault",
          }, {
            id: 203,
            name: "发型师评价",
            path: "/evaluate",
          }, {
            id: 204,
            name: "消费者投诉-微信",
            path: "/complaint",
          },],
        },
        {
          id: 3,
          name: "数据中心",
          icon: 'iconfont icon-shujuzonglan',
          childs: [{
            id: 101,
            name: "发型师数据",
            path: "/hair",
          }, {
            id: 103,
            name: "门店数据",
            path: "/storeData",
          }, {
            id: 104,
            name: "成本核算",
            path: "/cost",
          }, {
            id: 105,
            name: "发型师成本统计",
            path: "/workerCostCount",
          }],
        },
        {
          id: 4,
          name: "门店管理",
          icon: 'iconfont icon-mendianguanli',
          childs: [{
            id: 201,
            name: "门店列表",
            path: "/storeList",
          }, {
            id: 204,
            name: "排班管理",
            path: "/typeSetting",
          }, {
            id: 206,
            name: "物资管理",
            path: "/material01",
          }, {
            id: 207,
            name: "就餐时间",
            path: "/eatTime",
          }],
        },
        {
          id: 15,
          name: "加盟商管理",
          icon: 'iconfont icon-jiamengshang',
          childs: [{
            id: 1502,
            name: "加盟信息",
            path: "/notice",
          }, {
            id: 1501,
            name: "加盟管理",
            path: "/join",
          },],
        },
        {
          id: 5,
          name: "用户管理",
          icon: 'iconfont icon-yonghu',
          childs: [{
            id: 301,
            name: "用户列表",
            path: "/user_data"
          }, {
            id: 303,
            name: "企业用户",
            path: "/company_user"
          }, {
            id: 302,
            name: "用户运营",
            path: "/operaplan",
          }],
        },
        {
          id: 6,
          name: "产品管理",
          icon: 'iconfont icon-chanpinguanli',
          childs: [
            {
              id: 4021,
              name: "剪发服务",
              path: "/product_hair",
            }, {
              id: 4011,
              name: "黑卡会员",
              path: "/product_user",
            }, {
              id: 4012,
              name: "次卡管理",
              path: "/timeCard",
            }, {
              id: 4013,
              name: "套餐管理",
              path: "/productGroup",
            }, {
              id: 801,
              name: "首页轮播图",
              path: "/appletSettings",
            },
            {
              id: 4014,
              name: "卡金会员",
              path: "/ccard",
            },
            {
              id: 4015,
              name: "UVIP",
              path: "/uvip",
            },
          ]
        },
        {
          id: 7,
          name: "营销管理",
          icon: 'iconfont icon-yingxiaotuiguang',
          childs: [{
            id: 101,
            name: "券设置",
            path: "/volumeset"
          }, {
            id: 501,
            name: "券包设置",
            path: "/coupons",
          }, {
            id: 301,
            name: "兑换码",
            path: "/exchangecode",
          }, {
            id: 1401,
            name: "充值卡金",
            path: "/depositList",
          },
            {
              id: 201,
              name: "弹出广告",
              path: "/Advertisement"
            },
            {
              id: 709,
              name: "分享有礼",
              path: "/share",
            }, {
              id: 711,
              name: "扫码领券",
              path: "/scan",
            }, {
              id: 712,
              name: "兑换权益",
              path: "/exchange",
            }, {
              id: 131,
              name: "裂变活动",
              path: "/marketingShare",
            }, {
              id: 132,
              name: "现金红包",
              path: "/redPack",
            }, {
              id: 133,
              name: "分销",
              path: "/dis",
            }, {
              id: 134,
              name: "评价运营",
              path: "/review",
            },{
              id: 135,
              name: "美团设置",
              path: "/meituan/config",
            },

          ],
        },
        {
          id: 8,
          name: "发型师管理",
          icon: 'iconfont icon-faxingshi',
          childs: [{
            id: 603,
            name: "发型师列表",
            path: "/hairlist",
          }, {
            id: 602,
            name: "业绩查询",
            path: "/achievement",
          }, {
            id: 605,
            name: "定时调店",
            path: "/changeStore",
          }, {
            id: 606,
            name: "熟客抵扣",
            path: "/workerDiscount",
          },],
        },
        {
          id: 9,
          name: "积分商城",
          icon: 'iconfont icon-jifen',
          childs: [{
            id: 701,
            name: "积分设置",
            path: "/integralset",
          }, {
            id: 702,
            name: "订单列表",
            path: "/integralOrderList",
          }, {
            id: 703,
            name: "订单获取记录",
            path: "/integralget",
          },],
        },
        {
          id: 10,
          name: "系统设置",
          icon: 'iconfont icon-shezhi',
          childs: [{
            id: 801,
            name: "操作日志",
            path: "/journal",
          }, {
            id: 804,
            name: "操作模块",
            path: "/handle",
          }, {
            id: 803,
            name: "美团授权",
            path: "/meituan",
          },],
        },
        {
          id: 13,
          name: "抖音管理",
          icon: 'iconfont icon-douyin',
          childs: [{
            id: 1301,
            name: "抖音订单",
            path: "/dyOrderList",
          }, {
            id: 1302,
            name: "商品管理",
            path: "/dyGoods",
          },],
        },
        {
          id: 11,
          name: "财务管理",
          icon: 'iconfont icon-05',
          childs: [{
            id: 901,
            name: "支付设置",
            path: "/payment",
          }, {
            id: 903,
            name: "订单列表",
            path: "/assetManagement",
          }, {
            id: 907,
            name: "业绩提成",
            path: "/commission",
          }, {
            id: 906,
            name: "售后订单",
            path: "/Aftersales",
          }, {
            id: 904,
            name: "月度统计",
            path: "/monthManagement",
          }, {
            id: 905,
            name: "活动导出",
            path: "/ActivityExpore",
          }],
        },
      ],
      //   是否折叠
      isCollapse: false,
      // 当前激活选项
      activePath: '',
      dot: false,
      date1: '',
      nowDay: '',
    };
  },
  created() {
    this.activePath = sessionStorage.getItem('activePath')
  },
  mounted() {
    window.scrollTo(0, 0)
    // chrome
    document.body.scrollTop = 0
    // firefox
    document.documentElement.scrollTop = 0
    // safari
    window.pageYOffset = 0
    this.countDot()
    this.noFollowUp()
  },
  watch: {
    functin() {
      const {
        href
      } = this.$router.resolve({
        name: "订单列表",
        params: {
          id: 903,
          name: "订单列表",
          path: "/assetManagement",
        }
      });
      window.open(href, '_blank');
    }
  },
  methods: {
    // 退出登录
    outlogin() {
      this.$http.post("logout").then(function (res) {
        console.log(res)
        if (res.body.code == 200) {
          this.$message.success("退出成功")
          localStorage.removeItem('Authorization')
          this.$router.push({
            path: '/login'
          })
        }
      }, function (err) {
        this.$message.error("请求失败")
      })
    },
    //
    manage() {
      this.$router.push({
        path: "adminList",
      })
    },
    // 查看详情
    showxiangqing() {
      this.show_message = false
      this.$router.push({
        path: `notice`
      })
    },
    //打开消息
    openmessage() {
      this.show_message = true
    },
    // 翻页
    changePage(val) {
      this.filter.page = val
    },
    //   点击menu伸缩
    handleToggle() {
      this.isCollapse = !this.isCollapse;
    },
    // 点击激活当前菜单
    handleActiveMenus(path) {
      window.sessionStorage.setItem('activePath', path)
      this.activePath = path
    },
    // 评价管理红点
    countDot() {
      this.$http.get("evaluate/countDot").then(res => {
        if (res.body.code == 200) {
          if (res.body.data > 0) {
            this.dot = true
          } else {
            this.dot = false
          }
        }
      })
    },
    // 评价管理红点
    noFollowUp() {
      this.$http.get("DNotice/noFollowUp").then(res => {
        console.log(res)
        this.noFollowUpCount = res.body
      })
    },
  },
};
</script>
<style lang="less" scoped>
.el-container {
  height: 100%;

  .el-aside {
    background-color: #202239;
    scrollbar-width: none;
    transition: all 400ms ease;
    padding-top: 86.25px;

    &::-webkit-scrollbar {
      display: none;
    }

    .logo-active {
      width: 120px;
    }

    .logo-active1 {
      width: 200px;
    }

    .logo {
      margin: 0 0 0 -30px;
      position: fixed;
      z-index: 999;
      top: 0;
      background-color: #202239;
      width: 200px;
      text-align: center;
      transition-timing-function: linear;
      transition: all 400ms ease;

      img {
        width: 60%;
        margin: 20px 0 10px 0;
      }
    }

    .logo1 {
      position: fixed;
      z-index: 999;
      top: 0;
      width: 64px;
      background-color: #202239;
      text-align: center;
      transition-timing-function: linear;

      img {
        width: 50px;
        height: 50px;
        margin: 20px 0 10px 0;
      }
    }

    .el-menu {
      border-right: 0;

      .el-menu-item {
        .iconfont {
          margin-right: 8px;
          color: #fff;
        }
      }

      .el-submenu {
        .iconfont {
          margin-right: 8px;
          color: #fff;
        }

        .el-menu-item {
          background-color: #2C2E47 !important;
        }
      }
    }
  }

  .el-container {
    .el-header {
      height: 56px !important;
      box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);
      padding: 0 30px 0 10px;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .iconfont-active {
        transform: rotate(-90deg);
        transition: all 300ms ease;
      }

      .user_box {
        display: flex;
        align-items: center;

        .el-badge {
          cursor: pointer;
          margin-right: 50px;
        }

        .head {
          display: flex;
          align-items: flex-end;

          img {
            display: block;
            width: 40px;
            height: 40px;
            border-radius: 50%;
            background-color: #ccc;
          }

          i {
            margin-left: 10px;
            color: #585f66;
          }
        }
      }
    }

    .el-main {
      background-color: #fff;
      margin: 5px 0;

      .div-footer {
        // background-color: #f5f5f5;
        text-align: center;
        line-height: 40px;
        font-size: 16px;
        font-weight: 400;
        height: 40px !important;
        color: #3e3e3e;
        margin-top: 20px;
      }
    }
  }
}

/deep/ :focus {
  outline: 0;
}

.message_box {
  display: flex;
  flex-direction: column;
  height: calc(100vh - 80px);
  width: 100%;

  .showxiangqing {
    margin-top: 20px;
  }

  .matter {
    margin-top: -20px;

    .mynotice {
      box-sizing: border-box;
      padding-left: 15px;
      padding-right: 25px;
      padding-top: 10px;
      display: flex;

      .mynoswww {
        flex: 1;
      }

      .nos {
        color: red;
      }

      .wos {
        color: #72b7ff;
      }
    }
  }
}

/deep/ .el-submenu__title {
  color: #ffffff !important;
}

/deep/ .el-menu-item.is-active {
  color: #ffffff;
}

/deep/ .el-menu-item {
  // color: #FFFFFF;
}

/deep/ .el-icon-arrow-down:before {
  color: #FFFFFF;
}

/deep/ .el-badge__content.is-dot {
  background-color: #ff0000;
  border: 1px solid #ff0000;
  margin-top: -25px;
}

/deep/ .el-badge__content {
  background-color: #ff0000;
  border: 1px solid #ff0000;
}
</style>
